let _toast;
try {
  // attempt to import toast from react-toastify
  // if not available, _toast will be undefined and we'll fallback to alert
  // eslint-disable-next-line import/no-unresolved
  // (module resolution handled by bundler)
  // eslint-disable-next-line no-unused-vars
  const { toast } = require("react-toastify");
  _toast = toast;
} catch (e) {
  _toast = undefined;
}

export const showSuccess = (msg) => {
  if (_toast && typeof _toast.success === "function") {
    try {
      console.debug('[toast] using react-toastify success', msg);
      _toast.success(msg || "Success");
    } catch (e) {
      console.error('[toast] react-toastify success failed', e);
      try { window.alert(msg || "Success"); } catch (err) {}
    }
  } else {
    console.debug('[toast] react-toastify not available, falling back to alert', msg);
    try { window.alert(msg || "Success"); } catch (e) {}
  }
};

export const showError = (msg) => {
  if (_toast && typeof _toast.error === "function") {
    try {
      console.debug('[toast] using react-toastify error', msg);
      _toast.error(msg || "Something went wrong");
    } catch (e) {
      console.error('[toast] react-toastify error failed', e);
      try { window.alert(msg || "Something went wrong"); } catch (err) {}
    }
  } else {
    console.debug('[toast] react-toastify not available, falling back to alert', msg);
    try { window.alert(msg || "Something went wrong"); } catch (e) {}
  }
};

export const showInfo = (msg) => {
  if (_toast && typeof _toast.info === "function") {
    try {
      console.debug('[toast] using react-toastify info', msg);
      _toast.info(msg || "Info");
    } catch (e) {
      console.error('[toast] react-toastify info failed', e);
      try { window.alert(msg || "Info"); } catch (err) {}
    }
  } else {
    console.debug('[toast] react-toastify not available, falling back to alert', msg);
    try { window.alert(msg || "Info"); } catch (e) {}
  }
};

const toastApi = {
  showSuccess,
  showError,
  showInfo,
};

export default toastApi;
